import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * The motivation for having this class is to ensure that deeplink search queries with spaces
 * are properly loaded into the search box without '+' signs where there were spaces.
 * i.e. "/search?mockauth=2&q=foo%20bar" is displayed in search box as 'foo bar', and not 'foo+bar'
 * TODO: ensure this aligns with FlushUtilities onShellInfoLoaded URL parameters created by the server
 * TODO: ensure case with %2B in URL properly places a '+' sign into the Search query for the search box on refresh / deep link.
 */
@Injectable()
export class CustomUrlSerializer extends DefaultUrlSerializer {

    private readonly m365AppsPageRootPath = '/m365apps/';

    constructor() {
        super();
    }

    public parse(url: string): UrlTree {
        const urlParts = url.split('?');
        const lowerCasePath = urlParts[0].toLowerCase();
        if (!lowerCasePath.startsWith(this.m365AppsPageRootPath)) {
            urlParts[0] = lowerCasePath;
        } else {
            // MOSApp url is in the format of /m365apps/:appId/:entityId/:subEntityId
            // entityId and subEntityId are case sensitive. Should keep original casing.
            const processedPathSegments = urlParts[0].split('/').filter((segment => !!segment)).map((segment, index) => index < 2 ? segment.toLocaleLowerCase() : segment);
            urlParts[0] = '/' + processedPathSegments.join('/');
        }

        const newUrl = urlParts.join('?').replace(/\+/g, '%20');
        return super.parse(newUrl);
    }

    public serialize(tree: UrlTree): string {
        return super.serialize(tree).replace(/%20/g, '+');
    }
}
